const EventStatus = {
  DRAFT: "draft",
  CLOSED: "closed",
  OPENED: "opened",
  PUBLISHED: "publised",
  LIVE: "live"
};
export default EventStatus;
